export default "__VITE_ASSET__DGgyWPac__"